import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Experiment, ExperimentToggle, FeatureName, updateExperiment } from '../types'

export type ExperimentState = {
  [featureName: FeatureName]: Experiment
}

export const initialExperimentState: ExperimentState = {}

export const experimentSlice = createSlice({
  initialState: initialExperimentState,
  name: 'experiment',
  reducers: {
    reportError: {
      prepare<E extends Error>(featureName: FeatureName, error: E) {
        return {
          error,
          payload: featureName,
        }
      },
      reducer(state, { payload }: PayloadAction<FeatureName>) {
        if (state[payload]) {
          state[payload].hasError = true
        }
      },
    },
    startExperiment(state, { payload }: PayloadAction<FeatureName>) {
      if (state[payload]) {
        state[payload].started = true
      }
    },
    upsertExperiments: {
      prepare(data: ExperimentToggle[]) {
        return {
          payload: data,
        }
      },
      reducer(state, action: PayloadAction<ExperimentToggle[]>) {
        for (const { featureName, ...restProperties } of action.payload) {
          const experiment = updateExperiment(state[featureName], restProperties)
          if (experiment) {
            state[featureName] = experiment
          }
        }
      },
    },
  },
})

export const slice = experimentSlice
export function experimentStateSelector<RootState>(rootState: RootState): ExperimentState {
  return rootState[slice.name]
}
export const { name, reducer, actions, caseReducers } = experimentSlice
